import { useState, useCallback } from 'react'
import { appsyncQuery } from '../../../api/appsync-client.js'

const GET_CARD_HISTORY = `
  query GetCardHistory($cardId: String!, $userId: ID) {
    getCardHistory(cardId: $cardId, userId: $userId) {
      entries { sessionId value createdAt }
    }
  }
`

export function useCardHistory(cardId, userId) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetch = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const result = await appsyncQuery(GET_CARD_HISTORY, { cardId, userId: userId || undefined })
      const historyData = result.getCardHistory
      setData(historyData)
      return historyData
    } catch (err) {
      setError(err)
      return null
    } finally {
      setLoading(false)
    }
  }, [cardId, userId])

  return { data, loading, error, fetch }
}
